import { motion } from 'framer-motion';
import { Mail, Phone, MapPin, MessageCircle } from 'lucide-react';

const Footer = () => {
  const whatsappNumber = '+6289502452140';

  return (
    <footer className="bg-isk-dark text-white py-16 px-6 lg:px-12" data-testid="footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <img src="/isk-logo.png" alt="ISK" className="h-14 w-auto mb-4" />
            <p className="text-white/70 mb-6">
              Premium property management untuk meningkatkan ROI properti kost Anda dengan layanan profesional dan transparan.
            </p>
          </motion.div>

          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <h4 className="text-lg font-bold mb-4">Kontak</h4>
            <div className="space-y-3">
              <a 
                href="mailto:info@iskhouse.com" 
                className="flex items-center text-white/70 hover:text-white transition-colors"
                data-testid="footer-email"
              >
                <Mail className="w-5 h-5 mr-3" />
                info@iskhouse.com
              </a>
              <a 
                href={`tel:${whatsappNumber.replace(/[^0-9+]/g, '')}`}
                className="flex items-center text-white/70 hover:text-white transition-colors"
                data-testid="footer-phone"
              >
                <Phone className="w-5 h-5 mr-3" />
                {whatsappNumber}
              </a>
              <div className="flex items-start text-white/70">
                <MapPin className="w-5 h-5 mr-3 mt-1 flex-shrink-0" />
                <span>Jakarta, Indonesia</span>
              </div>
            </div>
          </motion.div>

          {/* Quick Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <div className="space-y-3">
              <button 
                onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
                className="block text-white/70 hover:text-white transition-colors text-left"
              >
                Services
              </button>
              <button 
                onClick={() => document.getElementById('partnership')?.scrollIntoView({ behavior: 'smooth' })}
                className="block text-white/70 hover:text-white transition-colors text-left"
              >
                Partnership
              </button>
              <button 
                onClick={() => document.getElementById('testimonials')?.scrollIntoView({ behavior: 'smooth' })}
                className="block text-white/70 hover:text-white transition-colors text-left"
              >
                Testimonies
              </button>
              <button 
                onClick={() => document.getElementById('faq')?.scrollIntoView({ behavior: 'smooth' })}
                className="block text-white/70 hover:text-white transition-colors text-left"
              >
                FAQ
              </button>
            </div>
          </motion.div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 text-center text-white/50 text-sm">
          <p>&copy; {new Date().getFullYear()} ISK. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
